export default __webpack_public_path__ + "static/media/disciplines.183e959a.svg";